import { render, staticRenderFns } from "./goodsdetail.vue?vue&type=template&id=9ba3965a&scoped=true&"
import script from "./goodsdetail.vue?vue&type=script&lang=js&"
export * from "./goodsdetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsdetail.vue?vue&type=style&index=0&id=9ba3965a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba3965a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ba3965a')) {
      api.createRecord('9ba3965a', component.options)
    } else {
      api.reload('9ba3965a', component.options)
    }
    module.hot.accept("./goodsdetail.vue?vue&type=template&id=9ba3965a&scoped=true&", function () {
      api.rerender('9ba3965a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goodsdetail.vue"
export default component.exports